var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-breadcrumb',{staticClass:"ele-header-breadcrumb ele-scrollbar-hide",attrs:{"separator":"/"}},_vm._l((_vm.levels),function(item,index){return _c('el-breadcrumb-item',{key:index,attrs:{"to":(index===0&&_vm.levels.length>1&&item.path)?{path: item.path}:null}},[_vm._v(_vm._s(item.meta.title)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }